import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useTranslation } from 'react-i18next';
import { languages } from '../data/languagesData';
import { Image } from 'react-bootstrap';

const Topbar = ({ aboutRef, roomsRef, locationRef, color, width }) => {
  const [currentLanguageFlag, setCurrentLanguageFlag] = useState(languages[0]?.image)

  const { t, i18n } = useTranslation()
  const language = i18n.resolvedLanguage
  const location = useLocation()
  const path = location.pathname
  const navigate = useNavigate();

  useEffect(() => {
    const currentLanguage = languages.filter(lang => lang.id === language)
    setCurrentLanguageFlag(currentLanguage[0]?.image)
  }, [language])

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang.id)
  }

  return (
    <Navbar 
      expand="xl" 
      className="topBarContainer" 
      variant="dark" 
      style={{"--color": path === '/' ? '0, 0, 0' : color}}
    >
      <Container style={{width: '90%', margin: '0 auto', alignItems: 'center'}}>
        <Navbar.Brand style={{color: '#FFF', zIndex: 1}} href="/">Gem Luxury Apartments</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav style={{width: '100%', justifyContent: 'center', marginLeft: width < 1200 ? '-1.5rem' :'-10%'}}>
            <Nav.Link onClick={() => aboutRef ? aboutRef.current?.scrollIntoView({behavior: 'smooth'}) : navigate('/')}>{t('aboutus')}</Nav.Link>
            <Nav.Link onClick={() => roomsRef ? roomsRef.current?.scrollIntoView({behavior: 'smooth'}) : navigate('/')}>{t('ourRooms')}</Nav.Link>
            <Nav.Link onClick={() => locationRef ? locationRef.current?.scrollIntoView({behavior: 'smooth'}) : navigate('/')}>{t('ourLocation')}</Nav.Link>
          </Nav>

          {width < 1200 && 
            <NavDropdown 
              title={
                <Image src={currentLanguageFlag} style={{width: '2.25rem', marginRight: '.5rem'}} alt={language + "-language-flag"}/>
              } 
              id="navbarScrollingDropdown"
              style={{marginLeft: '-1.5rem'}}
            >
              {languages.map((language, index) => 
                <NavDropdown.Item key={`language-option-${index}`} className="align-items-center" onClick={() => handleLanguageChange(language)}>
                  <Image src={language.image} style={{width: '1.5rem', marginRight: '.5rem'}} alt={languages.id + "-language-flag"}/>
                  {language.name}
                </NavDropdown.Item>
              )}
            </NavDropdown>
          }
        </Navbar.Collapse>

        {width > 1199 && 
          <NavDropdown 
            title={
              <Image src={currentLanguageFlag} style={{width: '2.25rem', marginRight: '.5rem'}} alt={language + "-language-flag"}/>
            } 
            id="navbarScrollingDropdown"
          >
            {languages.map((language, index) => 
              <NavDropdown.Item key={`language-option-${index}`} className="align-items-center" onClick={() => handleLanguageChange(language)}>
                <Image src={language.image} style={{width: '1.5rem', marginRight: '.5rem'}} alt={languages.id + "-language-flag"}/>
                {language.name}
              </NavDropdown.Item>
            )}
          </NavDropdown>
        }
      </Container>
    </Navbar>
  )
}

export default Topbar